import { connect } from "react-redux";
import CustomAppBar from "../components/CustomAppBar";

const mapStateToProps = (state) => {
  const {
    uiState: { navBarTitle, appBarHidden },
  } = state;

  return {
    navBarTitle,
    appBarHidden,
  };
};

export default connect(mapStateToProps)(CustomAppBar);
